import { Flex, useDisclosure } from '@chakra-ui/react';
import ElementsImage from 'assets/images/elements.png';
import { NAVBAR_HEIGHT } from 'constants/editor';
import { UPGRADE_REDIRECT_BIZ_LINK, UPGRADE_REDIRECT_LINK } from 'constants/links';
import { CLICK_ON_PAID_FEATURE, UPGRADE } from 'constants/mixpanel';
import { useChameleon } from 'libs/third-party/Chameleon';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { getUserPlanProperty } from 'libs/third-party/Mixpanel/mixpanel.helper';
import { CommonGatedUpgradeModal } from 'modules/Editor/components/Modals/CommonGatedUpgradeModal';
import { ModalUpgradeTypeEnum } from 'modules/Editor/components/Modals/CommonGatedUpgradeModal.types';
import { TOOLBAR_HEIGHT } from 'modules/Editor/components/Toolbar';
import { UserType, UserTypes, useUser } from 'modules/User';
import { ReactElement, useCallback, useState } from 'react';
import { setAnalyticsUpgradeFeatureProp } from 'utils/sessionStorage';

import { ElementsPackView } from './ElementsPackView';

const UPGRADE_REDIRECT_LINKS_BY_TYPE: { [key: string]: string } = {
  [UserTypes.Free]: UPGRADE_REDIRECT_LINK,
  [UserTypes.Premium]: UPGRADE_REDIRECT_BIZ_LINK,
};

export const ElementsMenu = (): ReactElement => {
  const { trackChameleon } = useChameleon();
  const { userType } = useUser();
  const { isOpen: isUpgradeModal, onOpen: onOpenUpgradeModal, onClose: onCloseUpgradeModal } = useDisclosure();
  const [selectedModalUpgradePlan, setSelectedModalUpgradePlan] = useState<UserType>(UserTypes.Premium);

  const onGated = useCallback(() => {
    Mixpanel.track(UPGRADE.eventName, {
      Feature: UPGRADE.feature.Elements,
      'User Plan': getUserPlanProperty(userType),
    });
    trackChameleon(UPGRADE.eventName);

    setAnalyticsUpgradeFeatureProp(UPGRADE.feature.Elements, 'elements widget');
    window.open(UPGRADE_REDIRECT_LINKS_BY_TYPE[userType] || UPGRADE_REDIRECT_LINK, '_self');
  }, [userType, trackChameleon]);

  const onClickUpgradeModal = useCallback(
    (upgradePlan?: UserType) => {
      if (upgradePlan) setSelectedModalUpgradePlan(upgradePlan);

      onOpenUpgradeModal();
      Mixpanel.track(CLICK_ON_PAID_FEATURE.eventName, {
        Feature: UPGRADE.feature.Elements,
        'User Plan': getUserPlanProperty(userType),
      });
    },
    [onOpenUpgradeModal, userType],
  );

  const onClickUpgrade = useCallback(onGated, [onGated]);

  return (
    <Flex
      direction={'column'}
      paddingY={4}
      paddingLeft={4}
      maxHeight={`calc(100vh - ${NAVBAR_HEIGHT + TOOLBAR_HEIGHT}px)`}
      overflowY='auto'
      h='full'
    >
      <ElementsPackView onClickUpgradeModal={onClickUpgradeModal} />
      <CommonGatedUpgradeModal
        isOpen={isUpgradeModal}
        onClose={onCloseUpgradeModal}
        onClickUpgrade={onClickUpgrade}
        upgradePlan={selectedModalUpgradePlan}
        modalImg={ElementsImage}
        modalType={ModalUpgradeTypeEnum.Elements}
      />
    </Flex>
  );
};

ElementsMenu.displayName = 'ElementsMenu';
